import { render, staticRenderFns } from "./CardDna.vue?vue&type=template&id=034ffaaa&"
import script from "./CardDna.vue?vue&type=script&lang=js&"
export * from "./CardDna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports